<template>
  <router-view v-slot="{ Component, route }">
    <transition :name="transitionName" :css="Boolean(transitionName)" :mode="transitionMode">
      <keep-alive :include="cachedTabs">
        <component :is="Component" :key="route.name" />
      </keep-alive>
    </transition>
  </router-view>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { transitionName } from 'src/router';

import * as branchService from 'src/services/branch';

const cachedTabs = [
  'SearchPage',
  'HotelResultsPage',
  'BookingListPage',
  'AccountOptionsPage',
  'WalletPage',
];

// @note On popstate (empty transitionName) we also drop mode="out-in" so the
// old page doesn't unmount while the new lazy-loaded route resolves — that
// async gap was showing as a white flash during iOS swipe-back/forward.
// 'default' runs enter/leave simultaneously.
const transitionMode = computed<'out-in' | 'default'>(() =>
  transitionName.value ? 'out-in' : 'default',
);

onMounted(() => {
  branchService.initBranch();
});
</script>
